import React from 'react';
import { Card, Container, Grid, Header } from 'semantic-ui-react';
import styled from 'styled-components';
import Footer from '../components/common/Footer';
import Navbar from '../components/common/Navbar';

const ContentWrapper = styled.div`
    padding-top: 4em;
    padding-left: 25%;
    padding-right: 25%;
    flex: 1;

    @media (max-width: 768px) {
        padding-left: 5%;
        padding-right: 5%;
    }
`;

const FlexContainer = styled(Container)`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
`;

const AnnouncementCard = styled(Card)`
    border-radius: 5px !important;
    background-color: #f2f2f2 !important;
    font-weight: 500 !important;
    color: black !important;
    box-shadow: 0 0 0 0 !important;
    text-align: left !important;
    padding: 1em !important;
    overflow: hidden !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    margin-bottom: 2em !important;
    width: 100% !important;
`;

const AnnouncementTitle = styled(Header)`
    font-size: 18px !important;
    font-weight: 700 !important;
    margin-bottom: 0.5em !important;
    color: #007bff !important;
`;

const AnnouncementDate = styled(Header)`
    font-size: 16px !important;
    font-weight: 700 !important;
    margin-bottom: 1em !important;
`;

const AnnouncementContent = styled.div`
    font-size: 1.2em;
    font-weight: 400;
    white-space: pre-line;
`;

const announcements = [
    {
        id: 1,
        title: 'CULPA Updates',
        date: 'April 16, 2023',
        content:
            "Dear CULPA users,\n\nAs our community continues to grow, we have been working hard to perfect CULPA to best serve you all! So what has changed? Well, we'd like to announce that we resolved many database issues since our relaunch in 2022 to improve the search experience. We will continue to refine the database to produce the best user experience.\n\nIn addition, we updated the homepage to display the most recent reviews. Check out your peers' new reviews for their experiences with all the classes offered at Columbia! We also plan to bring new features to CULPA, such as professor quotes and syllabus submissions. We believe these features will further help inform students' decision-making process when planning their classes. As we continue to work on improving the site, we'd appreciate it if you let us know about any bugs or inconsistencies here. We hope you're enjoying your experience with CULPA so far!\n\nBest,\nThe CULPA Team",
    },
    {
        id: 2,
        title: "A Brief Update: We're back!",
        date: 'November 14, 2022',
        content:
            "Dear CULPA users,\n\nCertainly, many in the community noticed when CULPA went down in the fall of 2021. What happened to CULPA? Why has it been gone for so long? What about the many other CULPA's that have popped up in the original CULPA's absence? Today, we're happy to announce that CULPA is officially back in full capacity! We'd like to provide some transparency on where CULPA has been, why it looks different, and what you can expect from CULPA going forward.\n\nCULPA is a website that has been part of Columbia tradition since its inception in 1997. There's a fun article on wikicu that summarizes CULPA's past up to 2008. By 2020, though, many of the technologies that CULPA was dependent on had become outdated. The last official CULPA team redesigned and reengineered the site from scratch in 2020 with the aim of ensuring that CULPA would be technologically sustainable for the foreseeable future.\n\nThe version of CULPA that you see now was designed and developed by that last official student team working on CULPA, consisting of Jonathan Zhang, Sungbin Kim, Elaine Wang, Jin Woo Won, Dorrie Tang, Pelin Cetin, Laura Block, Tamanna Hussain, and Kathy Lau. Enormous progress was made, though many of the team members graduated before the project could be completed. In the fall of 2021, the old CULPA fell into disrepair without an active undergraduate development team to complete the new version. As a temporary solution, a previous CULPA admin worked with Jonathan and crew to launch culpa.app as a temporary service to display existing reviews and collect new review submissions as the CULPA team sought a new home for CULPA at Columbia.\n\nIn the fall of 2022, CULPA entered into an agreement with the Spectator Publishing Company to transfer the ownership of CULPA as an organization to Spectator. And that brings us to the present! Throughout this semester, our teams have worked alongside alumni from the last official student CULPA team to complete development on the site and fulfill the original vision of the redesign. Moving forward, CULPA will functionally be operated as a subsidiary by the Product and Engineering teams at Spectator with an independent student team for moderation.\n\nIf you submitted reviews to culpa.app, worry not! We've gotten hold of your reviews and are working on publishing them in the coming weeks—we now also have an active moderation team that will review submissions on a weekly basis. Additionally, besides the new look and feel of the site, you may notice some quality of life updates including review sorting, the addition of the bronze nugget, and a cleaner database (far fewer duplicate classes and professors!). But we recognize that there's still a lot of work to be done. If you notice any bugs or inconsistencies with the site, we'd appreciate it if you let us know about them here. We hope that you are as thrilled as we are about CULPA's return!\n\nBest,\nThe CULPA Team",
    },
];

const AnnouncementsPage = () => (
    <>
        <Navbar />
        <FlexContainer style={{ width: '100vw', paddingBottom: '5em' }}>
            <ContentWrapper>
                <h1>Announcements</h1>

                {announcements.map((announcement) => (
                    <AnnouncementCard key={announcement.id} fluid>
                        <Grid stackable divided className="margin-0">
                            <Grid.Column width={16}>
                                <AnnouncementTitle>
                                    {announcement.title}
                                </AnnouncementTitle>
                                <AnnouncementDate>
                                    {announcement.date}
                                </AnnouncementDate>
                                <AnnouncementContent>
                                    {announcement.content}
                                </AnnouncementContent>
                            </Grid.Column>
                        </Grid>
                    </AnnouncementCard>
                ))}
            </ContentWrapper>
        </FlexContainer>
        <br />
        <br />
        <Footer />
    </>
);

export default AnnouncementsPage;
